import { render, staticRenderFns } from "./viewDelivery.vue?vue&type=template&id=2bb18268&scoped=true"
import script from "./viewDelivery.vue?vue&type=script&lang=js"
export * from "./viewDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb18268",
  null
  
)

export default component.exports